import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=6c2b3891&scoped=true&"
import script from "./JobList.vue?vue&type=script&lang=ts&"
export * from "./JobList.vue?vue&type=script&lang=ts&"
import style0 from "./JobList.vue?vue&type=style&index=0&id=6c2b3891&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b3891",
  null
  
)

export default component.exports